import { render, staticRenderFns } from "./Ativa.vue?vue&type=template&id=a78dcd56&"
import script from "./Ativa.vue?vue&type=script&lang=js&"
export * from "./Ativa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports